export const openWhatsSupport = () => {
  const url = 'https://digital.einstein.br/suporte_cockpit'
  window.open(url, '_blank')
}
